export default "/images/details.svg?a442eaf1d40c72b2db8994401761d60d";